import { FileSelectionState, UploadState } from '@asset-metrix/portal-ui';

export const uploadStartedStates: UploadState[] = [
  'isPending',
  'isSuccess',
  'isError',
];

export function areMetadataInputsDisabled(
  fileState: FileSelectionState,
  metadataInputsLocked: boolean
): boolean {
  return (
    metadataInputsLocked ||
    fileState.some((selection) =>
      uploadStartedStates.includes(selection.uploadState)
    )
  );
}
